import InlineMarkdown from './InlineMarkdown';

interface IRiskCalloutsBannerProps {
  riskCallouts: string[];
}

/**
 * Loud red-tinted banner for the LLM-generated risk callouts. Sits directly
 * under the sticky action header so the operator sees them before reading
 * anything else — these are the "do not ship without thinking about this"
 * items.
 */
const RiskCalloutsBanner = ({ riskCallouts }: IRiskCalloutsBannerProps) => {
  if (riskCallouts.length === 0) {
    return null;
  }
  return (
    <div className="border-border-error_subtle bg-bg-error-primary/40 border px-4 py-3">
      <h2 className="text-fg-error-primary mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider">
        <span aria-hidden="true">⚠</span>
        Risk Callouts
      </h2>
      <ul className="text-fg-primary marker:text-fg-error-primary flex list-disc flex-col gap-1.5 pl-5 text-sm">
        {riskCallouts.map((line, index) => (
          <li key={index}>
            <InlineMarkdown text={line} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RiskCalloutsBanner;
